abstract class AutocompleteAdapter<T, K> {
	abstract fetch(source: T): Promise<Array<K>>;
}

export default AutocompleteAdapter;
